import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import LinkOrAnchor from 'components/Shared/LinkOrAnchor';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import { getBrowseURL } from 'helpers/HelperFunctions';
import styles from './BrowseCTA.module.scss';

const BrowseCTA = ({
  browseURL,
  browseFilter,
  bsStyle,
  bsSize,
  handleOnClick,
  title,
}) => (
  <LinkOrAnchor
    isLink={!(browseURL && browseURL.includes('post-a-job'))}
    to={browseURL || getBrowseURL(browseFilter)}
  >
    <div className={styles.browseContainer}>
      <Button bsStyle={bsStyle} bsSize={bsSize} onClick={handleOnClick}>
        <div className={styles.browseCTA}>
          <span className={styles.browseCopy}>
            {title || 'Browse freelancers'}
          </span>
          <SvgIcon icon="chevron-right" size="14" />
        </div>
      </Button>
    </div>
  </LinkOrAnchor>
);

BrowseCTA.propTypes = {
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  browseURL: PropTypes.string,
  browseFilter: PropTypes.shape({
    role: PropTypes.string,
    skill: PropTypes.string,
    country: PropTypes.string,
    city: PropTypes.string,
    location: PropTypes.string,
  }),
  title: PropTypes.string,
  handleOnClick: PropTypes.func,
};

BrowseCTA.defaultProps = {
  bsStyle: 'primary',
  bsSize: 'lg',
};

export default BrowseCTA;
